// For Global ATC Button

class RuffATC extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('[data-atc-button]');
    this.variantId = this.dataset.variant;

    if (!this.button || !this.variantId) return;

    this.button.addEventListener(
      'click',
      this.handleAddToCart.bind(this)
    );

  }

  async handleAddToCart(e) {
    e.preventDefault();

    if (this.button.classList.contains('loading')) return;
    this.button.classList.add('loading');

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: Number(this.variantId),
              quantity: 1
            }
          ]
        })
      });

      if (!response.ok) {
        throw new Error('Add to cart failed');
      }

      document.documentElement.dispatchEvent (
        new CustomEvent('cart:refresh', {
          bubbles: true
        })
      );

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:open', {
          bubbles: true
        })
      );

    } catch (error) {
      console.error(error);
    } finally {
      this.button.classList.remove('loading');
    }
  }
}

if (!customElements.get('ruff-atc')) {
  customElements.define('ruff-atc', RuffATC);
}